<template>
  <div>
    <container>
      <div slot="left_box_content">
        <component :is="curLeftComponent" ></component>
      </div>
      <div slot="right_box_content">
        <component :is="curRightComponent" ></component>
      </div>
      <div
        slot="bottom_box_content"
      >
        <component
          ref="bottom"
          :is="curBottomComponent"
        ></component>
      </div>
      <div slot="bg_map"></div>
    </container>
  </div>
</template>
<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'
import investmentElecConsumptionStoreModule from '@/store/modules/investmentElecConsumption'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    Bottom: () => import('./consumptionComponets/Bottom.vue')
    // Right: () => import('./consumptionComponets/Right.vue')
  },
  created () {
    if (!this.$store.hasModule('investmentElecConsumption')) {
      this.$store.registerModule('investmentElecConsumption', investmentElecConsumptionStoreModule)
    }
  },
  mounted () {
    this.setShowLeftBlock(false)
    this.setShowRightBlock(false)
    this.setShowMap(false)
    this.setBottomHeight('90%')
    this.setBottomComponent('Bottom')
    this.setLeftComponent('')
    this.setRightComponent('')
  },
  destroyed () {
    this.$store.unregisterModule('investmentElecConsumption')
    this.setShowLeftBlock(false)
    this.setShowMap(false)
    this.setShowRightBlock(false)
    this.setBottomHeight('90%')
    this.setLinkTagArray()
    this.setLinkRouterMaps()
    this.setActivedTagName('')
  }
}
</script>
